<template>
  <div>
    <div class="table-responsive">
      <div class="text-left"></div>
      <div class="text-right mb-3">
        <h5 style="display: inline; float: left">Config Color Line</h5>
        <b-button
          size="md"
          v-b-modal.add-banner
          variant="primary"
          v-on:click="newList"
          >Add New Item</b-button
        >
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="80">Sort</th>
            <th>EN Name/TH Name</th>
            <th>Color</th>
            <th>Last Update</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in data" :key="list.id">
            <td>
              <b-form-select
                name
                id
                :value="list.orderNum"
                :sync="true"
                v-on:change="updateSorting($event, list)"
              >
                <option
                  v-for="(ls, index) in orderList"
                  :value="ls"
                  :key="index + 1"
                >
                  {{ index + 1 }}
                </option>
              </b-form-select>
            </td>
            <td>{{ list.title.en }} / {{ list.title.th }}</td>
            <td>
              <div
                class="color-box"
                :style="{ 'background-color': `rgb(${list.color})` }"
              ></div>
            </td>
            <td>{{ renderDate(list.updatedAt) }}</td>
            <td>
              <b-button-group>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="btn-group-space"
                  @click="edit(list)"
                  >Edit</b-button
                >
                <b-button
                  size="sm"
                  variant="outline-danger"
                  class="btn-group-space"
                  v-on:click="onDeleteData(list)"
                  >Delete</b-button
                >
              </b-button-group>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div id="table-pagination">
      <b-pagination
        v-model="paginate.page"
        :total-rows="paginate.totalRow"
        :per-page="paginate.limit"
        v-on:change="onUpdatePaginate"
      ></b-pagination>
      <b-form-select
        class="col-2 mx-2"
        v-model="paginate.limit"
        :options="perPageOptions"
        v-on:change="onUpdateLimit"
      ></b-form-select>
    </div>
    <EditColorLine :data="editData" :onSave="onSave" :onRefresh="onRefresh" />
  </div>
</template>

<script>
import format from 'date-fns/format'
import EditColorLine from '../modals/EditColorLine.modal'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    onCreateData: Function,
    onUpdateData: Function,
    onDeleteData: Function,
    onSetActive: Function,
    onUpdatePaginate: Function,
    onUpdateLimit: Function,
    onUpdateSort: Function,
    onRefresh: Function,
    paginate: {
      type: Object,
      default: () => {
        return {
          limit: 10,
          page: 1,
          totalPage: 1,
          totalRow: 0,
        }
      },
    },
  },
  components: {
    EditColorLine,
  },
  data: () => ({
    orderList: [],
    perPageOptions: [
      { value: 10, text: '10 / page' },
      { value: 20, text: '20 / page' },
      { value: 30, text: '30 / page' },
    ],
    editData: null,
  }),
  methods: {
    edit($data) {
      this.editData = Object.assign({}, $data)
      this.$bvModal.show('edit-color-line')
    },
    newList() {
      this.edit({
        title: {
          th: '',
          en: '',
        },
        color: '255,255,255',
        status: 'Active',
        visitor: '127.0.0.1',
      })
    },
    renderDate(date) {
      return date ? format(date, 'YYYY-MM-DD') : ''
    },
    updateSorting($newVal, $data) {
      let dataSort = {
        id: $data.id,
        orderNew: $newVal,
        orderOld: $data.orderNum,
      }

      this.onUpdateSort(dataSort)
    },
    onSave($data) {
      if (!$data.id) {
        this.onCreateData($data)
      } else {
        this.onUpdateData($data)
      }
    },
  },
  watch: {
    'paginate.totalRow': function (newVal, oldVal) {
      this.orderList = []
      for (let ls = 1; ls <= newVal; ls++) {
        this.orderList.push(ls)
      }
    },
  },
}
</script>

<style>
.yellobutton {
  background-color: rgb(0, 204, 0);
  border: 1px solid rgb(0, 204, 0);
}
.btn-group-space.yellobutton:hover {
  background-color: rgb(19, 173, 96);
  border: 1px solid rgb(19, 173, 96);
}
.redbutton {
  background-color: rgb(233, 0, 0);
  border: 1px solid rgb(233, 0, 0);
}
.redbutton:hover {
  background-color: rgb(165, 0, 0);
  border: 1px solid rgb(165, 0, 0);
}
.banner {
  max-width: 200px;
  max-height: 50px;
}
.start_stop_date {
  font-size: 12px;
  margin: 0px;
  color: #000;
}
td {
  vertical-align: middle !important;
  font-size: 14px;
}
#table-pagination {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.btn-group-space {
  margin-left: 5px;
  margin-right: 5px;
  min-width: 80px;
}

/* th {
  text-align: center;
}
td {
  text-align: center;
} */

.color-box {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #cccccc;
  background-color: #4ac7ff;
}
</style>
